"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditorialPageSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const EditorialPageSkeleton = ({
  animation = 'pulse',
  className
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SkeletonRoot, {
  className: className,
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
    variant: "rectangular",
    width: "800px",
    height: "240px",
    animation: animation
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
    variant: "text",
    width: "500px",
    height: "120px",
    animation: animation
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
    variant: "text",
    width: "200px",
    height: "20px",
    animation: animation
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
    variant: "text",
    width: "200px",
    height: "20px",
    animation: animation
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
    variant: "rectangular",
    width: "100%",
    height: "500px",
    animation: animation
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
    variant: "rectangular",
    width: "800px",
    height: "500px",
    animation: animation
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
    variant: "rectangular",
    width: "100%",
    height: "500px",
    animation: animation
  })]
});
exports.EditorialPageSkeleton = EditorialPageSkeleton;
